<div class="dbbox-container" #containerWrapper>
  <div class="dbbox-header">
      <ng-container *ngIf="headerTemplateRef===undefined">
          <div class="dbbox-header-left">
              <ng-container *ngIf="tooltip === undefined || tooltip === null || tooltip === '';else headerWithTooltip">
                <span class="dbbox-header-title">{{ title }}</span>
              </ng-container>
              <ng-template #headerWithTooltip>
                <span class="dbbox-header-title" title="{{ tooltip }}">{{ title }}</span>
              </ng-template>
              <span class="dbbox-header-subtitle">{{ subTitle }}</span>
              <ng-content select=".header-left"></ng-content>
              <ng-container *ngTemplateOutlet="headerLeftTemplate"></ng-container>
          </div>
          <div class="dbbox-header-right">
              <ng-content select=".header-right"></ng-content>
              <ng-container *ngTemplateOutlet="headerRightTemplate"></ng-container>
              <span #headerRight></span>
              <button *ngFor="let button of headerRightButtons"
                      (click)="buttonClick($event, button)"
                      [class]="'dbbox-btn ' + button.cssClass"
                      [disabled]="button.disabled"
                      title="{{ button.text }}">
                  <span [class]="button.iconClass"></span>
              </button>
              <button class="dbbox-btn"
                      *ngIf="!hideSettingBtn"
                      (click)="settingButtonClick($event)">
                  <span class="fa fa-cog"></span>
              </button>
              <button class="dbbox-btn"
                      *ngIf="!hideCloseBtn"
                      (click)="closeButtonClick($event)">
                  <span class="fa fa-times"></span>
              </button>
          </div>
      </ng-container>
    <ng-container *ngIf="headerTemplateRef!==undefined">
      <div *ngTemplateOutlet="headerTemplateRef"></div>
    </ng-container>
  </div>
  <div class="dbbox-content-box">
    <div #contentWrapper class="dbbox-content-wrapper">
      <ng-content></ng-content>
    </div>
  </div>
</div>